import { Outlet, Navigate } from 'react-router-dom';
import { useIsAuthenticated } from '@/hooks/redux';
import AnimationLayout from '@/components/animation/AnimationLayout';

export function AuthLayout() {
  const isAuthenticated = useIsAuthenticated();
  const transactionCode = localStorage.getItem('transactionCode');

  // Redirect to dashboard if already authenticated
  if (isAuthenticated && transactionCode) {
    return <Navigate to="/transaction-code" replace />;
  } else if (isAuthenticated && !transactionCode) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <>
      <div className="min-h-screen flex">
        {/* Left branding panel (hidden on small screens) */}
        <div className="hidden md:flex w-1/2 auth-left items-center justify-center p-8">
          <div className="max-w-[560px] w-full flex-center flex-col">
            {/* Optional logo can be placed here */}
            <img className="w-52" src="/images/logo.png" />
          </div>
        </div>

        {/* Right form panel */}
        <div className="w-full md:w-1/2 auth-right flex flex-col p-5">
          <AnimationLayout className="flex-grow">
            <div className="flex-grow flex-center relative z-10">
              <div className="relative max-w-[560px] w-full mx-auto flex-center flex-col">
                <Outlet />
              </div>
            </div>
          </AnimationLayout>
        </div>
      </div>
    </>
  );
}
